import { LoaderData } from "@/components/vault/viewer/VaultObjectViewerModal";
import { HengeErrorFallback } from "@/engine/henge/fallback/HengeErrorFallback";
import HengeLoaderErrorBoundary from "@/engine/henge/fallback/HengeLoaderErrorBoundary";
import { HengeLoadingSuspense } from "@/engine/henge/fallback/HengeLoadingSuspense";
import { TransformControls } from "@/engine/viewer/loaders/TransformControls";
import useVaultStore, {
  useVaultStoreActions,
} from "@/stores/zustand/vault/useVaultStore";
import React, { RefObject } from "react";

const VaultObjectHengeLazyComponent = React.lazy(
  () => import("@/engine/henge/VaultObjectHenge"),
);
const VaultObjectUploadCapturePreviewHengeLazyComponent = React.lazy(
  () => import("@/engine/henge/VaultObjectUploadCapturePreviewHenge"),
);

interface VaultObjectDetailCardObjectProps {
  loaderData: LoaderData;
  resetCamera: {
    trigger: boolean;
    callback: () => void;
  };
  transformControlsRef: RefObject<TransformControls | undefined>;
  occludeTarget: RefObject<HTMLDivElement | null>[];
  wrapperSize: { width: number; height: number } | undefined;
  setWarnThumbnailClipping: React.Dispatch<React.SetStateAction<boolean>>;
}

export const VaultObject = ({
  loaderData,
  resetCamera,
  transformControlsRef,
  occludeTarget,
  wrapperSize,
  setWarnThumbnailClipping,
}: VaultObjectDetailCardObjectProps) => {
  const currentPage = useVaultStore((state) => state.currentPage);

  const { setCanvasStatus } = useVaultStoreActions();

  if (!loaderData) return null;
  return (
    <>
      <HengeLoaderErrorBoundary
        fallbackComponent={
          <HengeErrorFallback
            position={{ x: 0, y: 0, z: 0 }}
            size={{ x: 1, y: 1, z: 1 }}
          />
        }
      >
        {currentPage.endsWith("thumbnail") ? (
          <HengeLoadingSuspense
            LazyComponent={VaultObjectUploadCapturePreviewHengeLazyComponent}
            props={{
              loaderData,
              onLoad: () => {
                setCanvasStatus("render");
              },
              transformControlsRef,
              wrapperSize,
              setWarnThumbnailClipping,
            }}
            id={-1}
            position={{ x: 0, y: 0, z: 0 }}
            rotation={{ x: 0, y: 0, z: 0 }}
            size={{ x: 1, y: 1, z: 1 }}
          />
        ) : (
          <HengeLoadingSuspense
            LazyComponent={VaultObjectHengeLazyComponent}
            props={{
              loaderData,
              onLoad: () => {
                setCanvasStatus("render");
              },
              resetCamera,
              occludeTarget,
              wrapperSize,
            }}
            id={-1}
            position={{ x: 0, y: 0, z: 0 }}
            rotation={{ x: 0, y: 0, z: 0 }}
            size={{ x: 1, y: 1, z: 1 }}
          />
        )}
      </HengeLoaderErrorBoundary>
    </>
  );
};
